module.exports = __webpack_public_path__ + "static/video-hero-72ad429009bf42667ced85f94a15215c.mp4";